/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.cartElement = document.querySelector('cart-form');   
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    this.cartElement = document.querySelector('cart-form');
    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');   

    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    if(this.querySelector('[data-qty-container]')){
      this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    }
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    const submitButton = this.querySelector('button[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');
    const hasminimumlimit = this.querySelector('[data-qty-input]')?.min;
    const hasmmaximumlimit = this.querySelector('[data-qty-input]')?.max;
    const variant_id_input = this.querySelector('[name="id"]');
    let added_qty = 0;
    if(!(hasminimumlimit &&  parseInt(hasminimumlimit) <= parseInt(qtyInput.value) ) && hasminimumlimit){
      return;
    }
    if(variant_id_input && variant_id_input.value){
    let currently_added_items = globalVariables.cart.items.find(p=>p.variant_id == variant_id_input.value);
    if(currently_added_items && currently_added_items.quantity){
      added_qty = parseInt(currently_added_items.quantity); 
    }
    }
    if(hasmmaximumlimit &&  (parseInt(qtyInput.value) + added_qty) > parseInt(hasmmaximumlimit)){
      let max = parseInt(hasmmaximumlimit);
      if(max - added_qty > 0){
        qtyInput.value = max - added_qty 
      }else{
        this.querySelector('.formwrapper')?.classList.add('d-none');
        this.querySelector('[data-qty-max-limit-exceeded]')?.classList.remove('d-none');
        return;
      }
    }
    submitButton.setAttribute('disabled',true);
    submitButton.classList.add('loading');
  
    addItems.push(JSON.parse(Utility.serializeForm(this.form)));
    const body = JSON.stringify({
      items: addItems,
      sections: `${((window.globalVariables.template == 'cart') ? 'template-cart' : 'component-cart-drawer')},header` 
    });
    fetch(`${routes.cart_add_url}`, { ...Utility.fetchConfig(), body })
    .then((response) => response.json())
    .then((res) => {
      let dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));
      //console.log('dataJSON===>', dataJSON);
      if(dataJSON.errors){
        if(window.notificationEle){
          window.notificationEle.updateNotification('Add to Cart', dataJSON.errors, {
          type: 'error',
          timeout: 8000
        });
        }
        return;
      }

      if(document.querySelector('#PopupModal-quickshop')){
        document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
      }
      //console.log(qtyInput);
      if(qtyInput && (!qtyInput.dataset.inputype)) {
         qtyInput.value = (qtyInput.min>1)?qtyInput.min : 1;
      }
     
      if(hasmmaximumlimit &&  (parseInt(dataJSON.items[0].quantity) >= parseInt(hasmmaximumlimit))){
        this.querySelector('.formwrapper')?.classList.add('d-none');
        this.querySelector('[data-qty-max-limit-exceeded]')?.classList.remove('d-none');
      }
      if(this.cartElement){
        this.cartElement._updateCart(dataJSON.sections, 'open_drawer');
      }else{
        window.location.href = window.routes.cart_fetch_url;
      }      
    })
    .catch((e) => {
      if(window.notificationEle){
        window.notificationEle.updateNotification('Error', e, {
          type: 'error',
          timeout: 5000
        });
      }
      console.error(e);
    })
    .finally(() => {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
   
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;
    let decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');
    let max_quantity_rule = $qtyInput.max || null;
    let min_quantity_rule = $qtyInput.min || null;
    /** set input quantity max rule based on the variant quantity tracker */
    //console.log("currentQty",currentQty)
    if(action != 'decrease' && max_quantity_rule && currentQty >= max_quantity_rule ){
      return;
    }
    if(action == 'decrease' && min_quantity_rule && currentQty <= min_quantity_rule){
      return;
    }
    /** close  quantity max rule */
    if(action == 'decrease' && currentQty <= 1){
      if(decreaseQtyBtn) decreaseQtyBtn.classList.add('disabled');
      return false;
    }else if(action == 'decrease'){
      finalQty = currentQty - 1;
      finalQty == 1 ? decreaseQtyBtn.classList.add('disabled') : decreaseQtyBtn.classList.remove('disabled');
    }else{
      if(decreaseQtyBtn) decreaseQtyBtn.classList.remove('disabled');
      finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
    $qtyInput.dispatchEvent(new Event('change')); 
  }
}
customElements.define('product-form', ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;
  }

  connectedCallback() {
    // Element Connected callback
    // Store initial button text from Liquid template
    if (this.addBtn) {
      const addTextEl = this.addBtn.querySelector('.add-text');
      if (addTextEl) {
        this.initialButtonText = addTextEl.textContent.trim();
      }
    }
    
    // Delay initial variant change to ensure window.productMeta is available
    if(this.formType == 'product-page') {
      // Wait for productMeta to be available
      const checkProductMeta = () => {
        if (window.productMeta) {
          this.onVariantChange('load');
        } else {
          // Retry after a short delay
          setTimeout(checkProductMeta, 50);
        }
      };
      checkProductMeta();
    }
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event 
   */
  onVariantChange(_event) {
    this.setCurrentVariant();
    
    if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;
    document.dispatchEvent(new Event('variant:changed'));
    
    if (!this.currentVariant) {
      this.toggleAddButton('disable');
      this.updateOptionLabel(this.form); 
    } else {
      if(this.formType == 'grid'){
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid); 
      }else{
        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
      }
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton('enable');
    }
  }

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid 
   */
  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = `?variant=${this.currentVariant.id}`;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    return fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
    });
  }

  /**
   * change value of currentVariant when variant being changed 
   */
  setCurrentVariant() {
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
      }
    });
  }

  /**
   * Update selected option name label
   */
  updateOptionLabel(form){
    let options = form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let labelID = 'option'+option.dataset.optionindex;
      const label = option.querySelector('.selected-option');
      if(!label || !labelID) return;
      label.textContent = this.currentVariant[labelID];
    });
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  /**
   * Render Price details based on current variant
   */
  priceUpdate(currentVariant, container){
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');

    if(priceElement) priceElement.textContent = Utility.formatMoney(currentVariant.price, window.globalVariables.money_format);;
    if(comparePriceElement) {
      comparePriceElement.textContent = Utility.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
      if(currentVariant.compare_at_price == null || currentVariant.compare_at_price <= 0 || currentVariant.compare_at_price == currentVariant.price){
        comparePriceElement.classList.add('d-none');
      }else{
        comparePriceElement.classList.remove('d-none');
      }
    }
  }

  /**
   * Render Product data based on current variant
   * @param {object} currentVariant 
   * @param {element} container 
   */
  renderProductInfo(currentVariant, container) {
    if(!currentVariant || !container) return;
   
    this.priceUpdate(currentVariant, container);
    this.updateOptionLabel(this.form); 

    const featured_image = currentVariant.featured_image || null;
    if(featured_image != null){
      if(this.formType == 'grid'){
        const featuredImage = container.querySelector('[data-feauredImage]');
        featuredImage.src = currentVariant.featured_image.src;
        featuredImage.srcset = currentVariant.featured_image.src;
      }else{
        let imageSlide = document.querySelector(`.product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
        if(this.formType == 'quickshop'){
          imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
        }
        if(!imageSlide) return;
  
        let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
        if(this.formType == 'quickshop' && quickShopSlider){
          quickShopSlider.slideTo(slideIndex, 0, false);
        }else if(productSlider){
          productSlider.slideTo(slideIndex, 0, false);
        }
      }
    }
  }

  /**
   * Get purchase state based on variant and product metadata
   * @param {object} variant - The variant object
   * @returns {string} - 'preorder', 'backorder', 'out_of_stock', or 'add_to_cart'
   */
  getPurchaseState(variant) {
    if (!variant) return null;

    // Ensure productMeta is available - return null to preserve initial state
    if (!window.productMeta) {
      return null;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const todayTime = today.getTime();

    let publishedDate = null;
    if (window.productMeta.publishedDate && window.productMeta.publishedDate !== '' && window.productMeta.publishedDate !== 'null') {
      try {
        const pubDate = new Date(`${window.productMeta.publishedDate}T00:00:00`);
        if (!isNaN(pubDate.getTime())) {
          publishedDate = pubDate.getTime();
        }
      } catch (e) {
        console.warn('Error parsing publishedDate:', e);
      }
    }

    let nextShipmentDate = null;
    if (window.productMeta.nextShipmentDate && window.productMeta.nextShipmentDate !== '' && window.productMeta.nextShipmentDate !== 'null') {
      try {
        const shipDate = new Date(`${window.productMeta.nextShipmentDate}T00:00:00`);
        if (!isNaN(shipDate.getTime())) {
          nextShipmentDate = shipDate.getTime();
        }
      } catch (e) {
        console.warn('Error parsing nextShipmentDate:', e);
      }
    }

    /**
     * Priority 1: PRE-ORDER - Published Date is in the future AND preorderable is true AND there is a future ship date
     */
    const preorderable = window.productMeta.preorderable;
    const isPreorder = publishedDate && publishedDate > todayTime && preorderable === true && nextShipmentDate && nextShipmentDate > todayTime;
    if (isPreorder) {
      return 'preorder';
    }
    
    // Debug logging (remove in production)
    if (window.location.search.includes('debug=button')) {
      console.log('Purchase State Debug:', {
        variant: variant.id,
        inventory_quantity: variant.inventory_quantity,
        inventory_policy: variant.inventory_policy,
        publishedDate: publishedDate ? new Date(publishedDate).toISOString() : null,
        nextShipmentDate: nextShipmentDate ? new Date(nextShipmentDate).toISOString() : null,
        preorderable: preorderable,
        todayTime: new Date(todayTime).toISOString(),
        isPreorder: isPreorder
      });
    }

    /**
     * Priority 2: BACKORDER - Out of stock + continue selling + (shipment in future OR published date in future but no ship date)
     * Only show if NOT preorder
     */
    if (!isPreorder &&
      variant.inventory_quantity < 1 &&
      variant.inventory_policy === 'continue'
    ) {
      // Show backorder if: shipment date is in future, OR published date is in future (but no ship date)
      const hasFutureShipment = nextShipmentDate && nextShipmentDate > todayTime;
      const hasFuturePublishedButNoShip = publishedDate && publishedDate > todayTime && preorderable === true && (!nextShipmentDate || nextShipmentDate <= todayTime);
      
      if (hasFutureShipment || hasFuturePublishedButNoShip) {
        return 'backorder';
      }
    }

    /**
     * Priority 3: OUT OF STOCK - Out of stock + continue selling unchecked
     */
    if (
      variant.inventory_quantity < 1 &&
      variant.inventory_policy !== 'continue'
    ) {
      return 'out_of_stock';
    }

    /**
     * Default: ADD TO CART
     */
    return 'add_to_cart';
  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut / preorder / backorder )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;

    // Hard disable
    if (status == 'disable') {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
      return;
    }

    if (!this.currentVariant) {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
      return;
    }

    const purchaseState = this.getPurchaseState(this.currentVariant);
    
    // If purchaseState is null, productMeta not ready yet - preserve initial state
    if (purchaseState === null) {
      // If we have initial button text, restore it
      if (this.initialButtonText) {
        const addTextEl = this.addBtn.querySelector('.add-text');
        if (addTextEl) {
          addTextEl.textContent = this.initialButtonText;
        }
      }
      return;
    }
    
    const addTextEl = this.addBtn.querySelector('.add-text');
    if (!addTextEl) return;
    
    const currentText = addTextEl.textContent.trim();
    const ariaLabel = this.addBtn.getAttribute('aria-label') || '';
    const preorderText = window.variantStrings.preOrder || 'Preorder';
    const backorderText = window.variantStrings.backorder || 'Backorder';
    const soldOutText = window.variantStrings.soldOut || 'Out of Stock';
    
    // Check what Liquid rendered (aria-label is set by Liquid and is more reliable)
    const ariaShowsPreorder = ariaLabel.trim() === preorderText;
    const ariaShowsBackorder = ariaLabel.trim() === backorderText;
    const ariaShowsSoldOut = ariaLabel.trim() === soldOutText;
    
    // Get expected text for current state
    let expectedText = '';
    switch (purchaseState) {
      case 'preorder':
        expectedText = preorderText;
        break;
      case 'backorder':
        expectedText = backorderText;
        break;
      case 'out_of_stock':
        expectedText = soldOutText;
        break;
      default:
        if (this.form.classList.contains('cart-upsell-form')) {
          expectedText = window.variantStrings.upsellAddText || 'Add';
        } else {
          expectedText = window.variantStrings.addToCart || 'Add to Cart';
        }
    }

    // Determine the actual state - use aria-label as source of truth for initial load,
    // but use calculated purchaseState for variant changes (aria-label doesn't update on variant change)
    let actualState = purchaseState;
    
    // On initial load, aria-label is set by Liquid and is reliable
    // On variant changes, we need to use the calculated purchaseState
    // Check if this is initial load (aria-label exists and matches a special state)
    if (ariaShowsPreorder) {
      actualState = 'preorder';
    } else if (ariaShowsBackorder) {
      actualState = 'backorder';
    } else if (ariaShowsSoldOut) {
      actualState = 'out_of_stock';
    }
    // Otherwise use purchaseState (which is calculated from current variant)
    
    // Update button text based on state
    // Use aria-label as source of truth - if it shows preorder/backorder/sold out, sync add-text to match
    if (ariaShowsPreorder) {
      // Liquid says preorder - sync add-text to match aria-label
      if (currentText !== preorderText) {
        addTextEl.textContent = preorderText;
      }
    } else if (ariaShowsBackorder) {
      // Liquid says backorder - sync add-text to match aria-label
      if (currentText !== backorderText) {
        addTextEl.textContent = backorderText;
      }
    } else if (ariaShowsSoldOut) {
      // Liquid says sold out - sync add-text to match aria-label
      if (currentText !== soldOutText) {
        addTextEl.textContent = soldOutText;
      }
      // Ensure button is disabled for sold out
      this.addBtn.setAttribute('disabled', true);
    } else {
      // Not a special state from Liquid, use calculated state
      if (currentText !== expectedText) {
        addTextEl.textContent = expectedText;
      }
    }
    
    // Handle button disabled state
    // Disable if: aria-label shows sold out OR purchaseState is out_of_stock
    if (ariaShowsSoldOut || purchaseState === 'out_of_stock') {
      this.addBtn.setAttribute('disabled', true);
    } else {
      // Enable button for all other states
      this.addBtn.removeAttribute('disabled');
    }

    // Properties are set by Liquid template - no JavaScript management needed
  }

  /**
   * Update hidden form properties based on purchase state
   * @param {string} state - The purchase state
   */
  updateOrderProperties(state) {
    const form = this.form;
    if (!form) return;

    // Remove existing flags
    ['__preorder', '__backorder'].forEach(name => {
      const input = form.querySelector(`input[name="properties[${name}]"]`);
      if (input) input.remove();
    });

    if (state === 'preorder') {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[__preorder]';
      input.value = 'Pre-Order';
      form.appendChild(input);
    }

    if (state === 'backorder') {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[__backorder]';
      input.value = 'Backorder';
      form.appendChild(input);
    }
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);

/**
 * Radio Button swatch
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form.dataset.format;

    const colorSwatchContainer = this.querySelector('.color-swatch');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
      });
    }
  }
}
customElements.define('variant-radios', VariantRadios);